module.exports = __webpack_public_path__ + "static/media/selfWaterColor.2096eb34.png";